<!--
 * @Description: 水印
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div v-if="IS_PLATFORM_TYPE_1" class="bi-tmpl-detail__right__cmpt">
    <div
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <span class="bi-tmpl-detail__right__cmpt__title">
        {{ curItem.title }}
      </span>
      <span>
        是否开启水印
        <BaseSwitch
          :disabled="disabled"
          @change="onOpenWaterMaker"
          :model-value="curItem.show"
        ></BaseSwitch>
      </span>
    </div>
    <div style="display: flex; gap: 32px">
      <!-- <BaseCard
        class="bi-card"
        @click="onChangeWaterMaker(TYPE_MAPPING[1].originImg)"
      >
        <div class="bi-card-content">
          <img
            :src="TYPE_MAPPING[1].scaleImg"
            alt="water-mark"
            style="width: 115px; height: 40px"
          />
          <BaseRadio
            :value="TYPE_MAPPING[1].originImg"
            :model-value="curItem.value"
          ></BaseRadio>
        </div>
      </BaseCard> -->
      <BaseCard
        class="bi-card"
        @click="onChangeWaterMaker(TYPE_MAPPING[2].originImg)"
      >
        <div class="bi-card-content">
          <div style="font-size: 22px; color: #e8e8e8">
            {{ enterpriseName }}
          </div>
          <BaseRadio
            :value="TYPE_MAPPING[2].originImg"
            :model-value="curItem.value"
          ></BaseRadio>
        </div>
      </BaseCard>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { BaseCard, BaseSwitch, BaseRadio } from 'xrk-components';
import { addWaterMark } from '@V/bi-tmpl/src/utils/water-mark';
import { uploadApi } from '@data-source/common/apis';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import appStore from '@/store';
import { IS_PLATFORM_TYPE_1 } from '@/config';

defineProps(['disabled']);

const { info } = storeToRefs(appStore.useUserStoreSetup);
const CHILD_KEY = '101_5';

const { curItem, onChange, onClear } = useDetailCmpt({ childKey: CHILD_KEY });

const COMMON_WATER_URL =
  'https://cdn.yxvzb.com/sunflower/bi/watermark/common.png';
const enterpriseName = info.value.entpName;
const enterpriseId = info.value.entpId;
const createWaterImg = () => {
  // 测试图片加载
  const img = new Image();
  img.src = `https://cdn.yxvzb.com/sunflower/bi/watermark/enterprise_${enterpriseId}.png`;
  img.onerror = async () => {
    // cdn没有该企业水印图
    // 上传水印图到cdn
    const data = await addWaterMark({
      text: enterpriseName,
      density: Math.abs(15 - enterpriseName.length),
      fileName: `enterprise_${enterpriseId}.png`
    });
    // url：https://cdn.yxvzb.com/sunflower/bi/watermark/enterprise_${id}.png
    // 将url给到TYPE_MAPPING[2].originImg
    const {
      data: { fileUrl }
    } = await uploadApi({ file: data.newFile });
    TYPE_MAPPING[2].originImg = fileUrl;
  };
  img.onload = () => {
    TYPE_MAPPING[2].originImg = img.src;
  };
};
onMounted(() => {
  createWaterImg();
});
const TYPE_MAPPING = {
  1: {
    originImg: COMMON_WATER_URL,
    scaleImg:
      'https://cdn.yxvzb.com/sunflower/bi/watermark/common_thumbnail.png'
  },
  2: {
    originImg: curItem.value === COMMON_WATER_URL ? '1' : curItem.value || '1', // 写死一个不存在的值，防止匹配到空字符串
    scaleImg: '1'
  }
};

const onChangeWaterMaker = originImg => {
  onChange(originImg);
};

const onOpenWaterMaker = e => {
  curItem.show = e;
  if (e) {
    onChange(TYPE_MAPPING[2].originImg);
  } else {
    onClear();
  }
};
</script>
<style lang="scss" scoped>
.bi-card {
  width: 420px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .bi-card-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
